import { createAction, props } from '@ngrx/store'
import { Country } from './country.state'

// Load all countries
export const loadCountries = createAction('[Country] Load Countries')

// Load a country by state selection
export const loadCountryByState = createAction(
  '[Country] Load Country by State',
  props<{ stateId: string }>()
)

// Success actions
export const loadCountriesSuccess = createAction(
  '[Country] Load Countries Success',
  props<{ countries: Country[] }>()
)

export const loadCountryByStateSuccess = createAction(
  '[Country] Load Country by State Success',
  props<{ country: Country }>()
)

// Failure action
export const loadCountryFailure = createAction(
  '[Country] Load Country Failure',
  props<{ error: string }>()
)
